import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const { googleLogin } = useAuth();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const user = await googleLogin(decodeURIComponent(m[1]));
        window.history.replaceState(null, "", "/");
        navigate(user.role === "customer" ? "/ricepoints" : "/", { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [googleLogin, navigate]);

  return <div className="min-h-[60vh] grid place-items-center text-muted-foreground">Signing you in…</div>;
}
